export function isDateRangeLongerThanAllowed(a: Date, b: Date, maxRangeDays: number): boolean {
    const [start, end] = getOrderedDates(a, b);

    if (maxRangeDays === 30) {
        return end > getCalendarMonthRangeEnd(start);
    }

    return getInclusiveRangeDays(end, start) > maxRangeDays;
}

function getOrderedDates(a: Date, b: Date): [Date, Date] {
    const first = stripTime(a);
    const second = stripTime(b);
    return first <= second ? [first, second] : [second, first];
}

function getCalendarMonthRangeEnd(start: Date): Date {
    if (isFirstDayOfMonth(start)) {
        return new Date(start.getFullYear(), start.getMonth() + 1, 0);
    }

    if (isLastDayOfMonth(start)) {
        return new Date(start.getFullYear(), start.getMonth() + 2, 0);
    }

    const nextMonthSameDay = addMonthsClamped(start, 1);
    return addDays(nextMonthSameDay, -1);
}

function addMonthsClamped(date: Date, months: number): Date {
    const targetFirst = new Date(date.getFullYear(), date.getMonth() + months, 1);
    const targetLastDay = new Date(targetFirst.getFullYear(), targetFirst.getMonth() + 1, 0).getDate();
    const targetDay = Math.min(date.getDate(), targetLastDay);

    return new Date(targetFirst.getFullYear(), targetFirst.getMonth(), targetDay);
}

function getInclusiveRangeDays(a: Date, b: Date): number {
    return Math.abs(diffInDays(a, b)) + 1;
}

function diffInDays(a: Date, b: Date): number {
    const diffMs = stripTime(a).getTime() - stripTime(b).getTime();
    return Math.round(diffMs / (1000 * 60 * 60 * 24));
}

function addDays(d: Date, days: number): Date {
    const result = new Date(d);
    result.setDate(result.getDate() + days);
    return stripTime(result);
}

function stripTime(d: Date): Date {
    return new Date(d.getFullYear(), d.getMonth(), d.getDate());
}

function isFirstDayOfMonth(date: Date): boolean {
    return date.getDate() === 1;
}

function isLastDayOfMonth(date: Date): boolean {
    return date.getDate() === new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
}
